import React, { useState } from 'react';
import axios from 'axios';

const AddUser = () => {
    const adminurl = 'https://htmlgames4u.com/api'
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
console.log('adminurl',adminurl)
    if (!name || !email) {
      setStatus('Name and email are required.');
      return;
    }

    try {
      const response = await axios.post(`${adminurl}/save-user`, {
        name,
        email,
      });

      if (response.data.success) {
        setStatus('User added successfully!');
        setName('');
        setEmail('');
      } else {
        setStatus(response.data.message || 'Failed to add user.');
      }
    } catch (error) {
      console.error('Error saving user:', error);
      setStatus('An error occurred while saving the user.');
    }
  };

  return (
    <div style={{display: 'flex',justifyContent: 'center'}}>
    <div style={{ margin: '20px', width: '400px', padding: '20px', boxShadow: '2px 4px 8px rgba(0,0,0,0.6)' }}>
      <h2>Add User</h2>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div>
          <label>User Name:</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="form-control"
          />
        </div>

        <div>
          <label>User Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="form-control"
          />
        </div>

        <button type="submit" className="btn btn-primary">Save User</button>

        {status && <div style={{ marginTop: '10px', color: 'green' }}>{status}</div>}
      </form>
    </div>
    </div>
  );
};

export default AddUser;
